import React from 'react'
import { InputWrapperIcon } from '@features/pricing/PricingCardControllers/styled'
import { InputSelect } from '@components/Form/InputSelect'
import { Button } from '@components/Basic/ButtonNbe'
import { useTranslation } from 'react-i18next'

export const BusinessController: React.FC = () => {
  const { t } = useTranslation()
  const options = [
    { value: 'value', label: t('billing.pricing.businessLabel') },
  ]

  return (
    <>
      <InputWrapperIcon>
        <InputSelect
          $hasMargin
          disabled
          name={'BusinessPLan'}
          $options={options}
        />
      </InputWrapperIcon>

      <InputWrapperIcon>
        <InputSelect disabled name={'BusinessPLan'} $options={options} />
      </InputWrapperIcon>

      <a
        target='_blank'
        href={`${process.env.REACT_APP_V1_URL}/support?t=PRICING_BILLING`}
        rel='noreferrer'
      >
        <Button $fluid $size={'large'} $variant={'primary'}>
          {t('billing.pricing.businessCta')}
        </Button>
      </a>
    </>
  )
}
